import client from "@/utils/client";

export const createPayment = (data: any) => {
  return client.post("/payment", data);
};
